import { Component, Input, OnInit } from '@angular/core';
import { NewsContentPageTableSection } from 'src/app/model/section/news-content-page-table-section';

import { documentToHtmlString } from '../api-reference-endpoints-table-section';

@Component({
  selector: 'app-news-content-page-table-section',
  templateUrl: './news-content-page-table-section.component.html',
  styleUrls: ['./news-content-page-table-section.component.scss']
})
export class NewsContentPageTableSectionComponent implements OnInit {
  @Input() tableSections: NewsContentPageTableSection[] = [];
  constructor() {}

  ngOnInit(): void {}
  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      return '<p>Error</p>';
    }

    return documentToHtmlString(richText);
  }
}
